import { useMutation, UseMutationResult, useQueryClient } from 'react-query';

import { getTokenWithType } from './useAuth';

import { addCustomRecords } from 'utils/urls';

import { ErrorModal } from 'types/modalTypes';

export async function postCustomRecords({
  params,
  accountId,
  lookupId,
}: TVariables): Promise<TResult> {
  const response = await fetch(addCustomRecords(accountId, lookupId), {
    method: 'POST',
    headers: {
      Authorization: getTokenWithType(),
      'content-type': 'application/json',
    },
    body: JSON.stringify({
      ...params,
    }),
  });
  return response.json();
}

type TError = ErrorModal;

type TResult = {
  Data: string;
  IsSuccess: boolean;
  StatusCode: number;
} & ErrorModal;

type TVariables = {
  params: any;
  accountId: number;
  lookupId: string;
};

type TSnapshot = unknown;

function useSaveCustomRecords(): UseMutationResult<
  TResult,
  TError,
  TVariables,
  TSnapshot
> {
  const queryClient = useQueryClient();
  return useMutation(async ({ params, accountId, lookupId }: TVariables) => {
    const newRecord = await postCustomRecords({ params, accountId, lookupId });
    if (newRecord.StatusCode === 200) {
      queryClient.invalidateQueries(['custom_records']);
      queryClient.invalidateQueries(['get_custom_table']);
    } else throw newRecord;

    return newRecord;
  });
}

export { useSaveCustomRecords };
